import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid"
import React from "react"

import Badge from "../../components/shared/Badge"
import { Button } from "../../components/shared/Buttons"
import { Box } from "../../components/shared/Layout"
import Typography from "../../components/shared/Typography"
import { usePractice } from "../../contexts/PracticeContext"
import { useToast } from "../../contexts/ToastContext"
import { formatPrice, formatDurationWithSessions } from "../../utils/utils"
import DisplayAvailableTimes from "../ProfileEdit/DisplayAvailableTimes"
import { buildPublicServiceUrl } from "../WebsiteBuilderV2/utils/urlUtils"

const ServiceCard = ({ service, onClick, servicesPagesEnabled }) => {
  const amount = service.amountCents === 0 ? "$0" : formatPrice(service.amountCents)

  const { practice } = usePractice()
  const { showToast } = useToast()

  const serviceUrl = buildPublicServiceUrl(service, practice)

  const copyPrivateLink = () => {
    navigator.clipboard.writeText(serviceUrl)
    showToast({ type: "success", content: "Private booking link copied" })
  }

  return (
    <Box key={service.id} className="w-full">
      {service.package && (
        <Badge type="info" className="mb-2 inline-block">
          Package
        </Badge>
      )}
      {service.public === false && (
        <Badge type="warning" className="mb-2 ml-2 inline-block">
          Private link only
        </Badge>
      )}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Typography variant="title">{service.name}</Typography>
          {servicesPagesEnabled && !service.addOn && (
            <a href={serviceUrl} target="_blank" rel="noopener noreferrer" className="text-gray-dark">
              <ArrowTopRightOnSquareIcon className="size-5" />
            </a>
          )}
        </div>
        <div className="flex items-center gap-2">
          <Button type="link" onClick={onClick}>
            Edit
          </Button>
          {service.public === false && servicesPagesEnabled && (
            <Button type="link" onClick={copyPrivateLink}>
              Copy link
            </Button>
          )}
        </div>
      </div>
      <Typography variant="smSubtitle">
        {service.addOn ? amount : `${formatDurationWithSessions(service.timeLength, service)} • ${amount}`}
      </Typography>
      <div className="mt-4 flex justify-between gap-4">
        <div
          className="wysiwyg-content text-sm"
          dangerouslySetInnerHTML={{
            __html: service.description.substring(0, 190) + (service.description.length > 190 ? "..." : "")
          }}
        />
        {service.smallWebpUrl && (
          <img src={service.smallWebpUrl} alt={service.name} className="size-16 flex-none rounded-lg" />
        )}
      </div>
      {service.availableTimesEnabled && (
        <DisplayAvailableTimes
          locationOrService={service}
          className="-m-8 mt-8 box-content flex flex-col gap-2 rounded-b-xl bg-gray-ultralight p-8 text-sm"
        />
      )}
    </Box>
  )
}

export default ServiceCard
